webpackJsonp([12],{

/***/ 1916:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1940),
  /* template */
  __webpack_require__(1977),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1940:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_leiloes_services_lote_restricoes__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__domain_tipo_restricao_services_tipo_restricao__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_components_popup_viewer_PopupViewer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__default_components_popup_viewer_PopupViewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__default_components_popup_viewer_PopupViewer__);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'novo-lote-restricoes',
  components: {
    PopupViewer: __WEBPACK_IMPORTED_MODULE_3__default_components_popup_viewer_PopupViewer___default.a,
    NovoTipoLoteRestricoes: function NovoTipoLoteRestricoes() {
      return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1972));
    }
  },
  props: {
    restricaoId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: function data() {
    return {
      isLoading: false,
      isLoaded: false,
      cadastroError: null,
      atualizadoSucesso: null,
      restricao: null,
      tiposRestricao: [],
      showTipoRestricaoForm: false,
      oldRestricao: null
    };
  },
  created: function created() {
    this.carregarTiposRestricao();
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.cadastroError = null;
      this.atualizadoSucesso = false;
      this.$bar.start();
      this.$parent.loading(true);
      __WEBPACK_IMPORTED_MODULE_1__domain_leiloes_services_lote_restricoes__["a" /* default */].cadastroRestricaoLote(this.$route.params.id, this.restricao, this.oldRestricao).then(function (response) {
        var callbackEnd = function callbackEnd() {
          _this.$emit('finishSubmit');
        };
        callbackEnd();
      }).catch(function (response) {
        _this.cadastroError = response.data.errors;
        _this.$nextTick(function () {
          _this.$refs.error.focus();
        });
        console.log(response);
      }).finally(function () {
        _this.$bar.finish();
        _this.$parent.loading(false);
      });
    },
    carregarTiposRestricao: function carregarTiposRestricao() {
      var _this2 = this;

      this.$parent.loading(true);
      __WEBPACK_IMPORTED_MODULE_2__domain_tipo_restricao_services_tipo_restricao__["a" /* default */].listAll().then(function (response) {
        _this2.tiposRestricao = response.data;
        _this2.oldRestricao = _this2.restricao = _this2.restricaoId;
      }).catch(function (error) {
        _this2.cadastroError = error.data.errors;
      }).finally(function () {
        _this2.$parent.loading(false);
        _this2.isLoaded = true;
      });
    },
    openTipoRestricaoForm: function openTipoRestricaoForm() {
      this.showTipoRestricaoForm = true;
    },
    closeTipoRestricaoForm: function closeTipoRestricaoForm() {
      this.showTipoRestricaoForm = false;
    },
    finishSubmitCadastroTipoRestricao: function finishSubmitCadastroTipoRestricao() {
      this.closeTipoRestricaoForm();
      this.carregarTiposRestricao();
    },
    printError: function printError(err) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["isArray"])(err)) {
        return err[0];
      }
      return err;
    }
  }
});

/***/ }),

/***/ 1977:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Gerenciamento de Restrições")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null && _vm.atualizadoSucesso) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.restricaoId && 'Atualizado' || 'Cadastrado') + " com sucesso!")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "bs-example form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Tipo")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.restricao),
      expression: "restricao"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.restricao = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.tiposRestricao), function(restricao) {
    return _c('option', {
      key: restricao.id,
      domProps: {
        "value": restricao.id
      }
    }, [_vm._v(_vm._s(restricao.nome))])
  })], 2), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-xs pull-right m-t-sm m-b-xs m-r-xs btn-default",
    attrs: {
      "to": {
        name: 'config.tipo-restricao.novo'
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Cadastrar nova restrição\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-xs btn-info m-r-xs",
    attrs: {
      "type": "submit"
    }
  }, [(!_vm.restricaoId) ? _c('span', [_vm._v("Cadastrar")]) : _vm._e(), _vm._v(" "), (_vm.restricaoId) ? _c('span', [_vm._v("Atualizar")]) : _vm._e()]), _vm._v(" "), _c('u-button', {
    staticClass: "btn m-b-xs w-xs m-r-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("Cancelar")])], 1)])])])]), _vm._v(" "), (_vm.showTipoRestricaoForm) ? _c('popup-viewer', {
    attrs: {
      "title": "Cadastro de Tipo de Restricao"
    },
    on: {
      "close": _vm.closeTipoRestricaoForm
    }
  }, [_c('NovoTipoLoteRestricoes', {
    on: {
      "cancel": _vm.closeTipoRestricaoForm,
      "finishSubmit": _vm.finishSubmitCadastroTipoRestricao
    }
  })], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/12.aa89befe02b81935362c.js